<template>
  <div class="relative inline-block text-left" @click="toggleVisible">
    <div v-click-away="onClickAway">
      <button v-if="!title"
        class="flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600"
        aria-label="Options"
        id="options-menu"
        aria-haspopup="true"
        aria-expanded="true"
      >
        {{title}}
        <svg v-if="!title" class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
          />
        </svg>
      </button>
      <button v-if="title"
        class="flex items-center text-gray-300 hover:text-gray-200 focus:outline-none focus:text-gray-400"
        aria-label="Options"
        id="options-menu"
        aria-haspopup="true"
        aria-expanded="true"
      >

        {{title}}
        <svg v-if="!title" class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
          />
        </svg>
      </button>
    </div>

    <!--
        Dropdown panel, show/hide based on dropdown state.

        Entering: "transition ease-out duration-100"
        From: "transform opacity-0 scale-95"
        To: "transform opacity-100 scale-100"
        Leaving: "transition ease-in duration-75"
        From: "transform opacity-100 scale-100"
        To: "transform opacity-0 scale-95"
    -->
    <div
      class="origin-top-right absolute mt-2 w-56 rounded-md shadow-lg z-10"
      :class="{'left-0': title, 'right-0': !title }"
      v-if="visible"
    >
      <div class="rounded-md bg-white shadow-xs">
        <div
          class="py-1"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
        >
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data: function() {
    return {
      visible: false
    }
  },
  props: [
    'title'
  ],
  methods: {
    toggleVisible: function() {
      this.visible = !this.visible
    },
    onClickAway: function() {
      this.visible = false;
    }
  }
};
</script>
